document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.literary-works').forEach(section => {
        const items = JSON.parse(section.dataset.itens || '[]');
        if (!items.length) return;

        const imagesContainer = section.querySelector('.literary-works__images');
        if (items.length === 1 && imagesContainer) imagesContainer.style.justifyContent = 'center';

        let index = 0;

        const contents = section.querySelectorAll('.literary-works__content');
        const images = [0,1,2].map(offset => section.querySelector(`#${section.id}-book-image-${offset}`));

        const prev = section.querySelector('.literary-works-button-prev');
        const next = section.querySelector('.literary-works-button-next');

        const update = (i) => {
            index = i;

            contents.forEach((el, idx) => {
                el.classList.toggle('is-active', idx === index);
            });

            images.forEach((img, offset) => {
                const item = items[(index + offset) % items.length];
                if (!item || !img) { img && (img.style.display = 'none'); return; }

                const url = item.image?.sizes?.['literary-thumb'] || item.image?.url || '';
                const alt = item.image?.description || item.image?.alt || item.image?.title || 'Capa do Livro';

                img.style.display = 'block';
                img.style.opacity = '0';
                setTimeout(() => { img.src = url; img.alt = alt; img.style.opacity = '1'; }, 300);
            });
        };

        prev && (prev.onclick = () => update((index - 1 + items.length) % items.length));
        next && (next.onclick = () => update((index + 1) % items.length));

        images.forEach((img, offset) => {
            if (offset === 0 || !img) return;
            img.style.cursor = 'pointer';
            img.onclick = () => update((index + offset) % items.length);
        });

        update(index);
    });
});